import { render, staticRenderFns } from "./scoreScaleDeveloped.vue?vue&type=template&id=22f64e05&scoped=true"
import script from "./scoreScaleDeveloped.vue?vue&type=script&lang=js"
export * from "./scoreScaleDeveloped.vue?vue&type=script&lang=js"
import style0 from "./scoreScaleDeveloped.vue?vue&type=style&index=0&id=22f64e05&prod&lang=scss&scoped=true"
import style1 from "./scoreScaleDeveloped.vue?vue&type=style&index=1&id=22f64e05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f64e05",
  null
  
)

export default component.exports